export default __webpack_public_path__ + "static/media/p-plus-4.f61e67da.svg";